// Nombres de fichero de las capturas de módulo (LDT-717). Ver Screenshot.tsx.

/** Anchos generados para cada captura. El de 1280 no lleva sufijo. */
export const SCREENSHOT_WIDTHS = [640, 960, 1280] as const;
export const SCREENSHOT_SIZE = { width: 1280, height: 845 } as const;

export function screenshotFile(shot: string, width: number, ext: "avif" | "webp") {
  return width === 1280 ? `${shot}.${ext}` : `${shot}-${width}.${ext}`;
}

export function screenshotSrcSet(shot: string, ext: "avif" | "webp") {
  return SCREENSHOT_WIDTHS.map((w) => `${screenshotFile(shot, w, ext)} ${w}w`).join(", ");
}
